import {   types } from '../../actions'
   
function getDivisions(seasons){
       
    const seasonDivisions = {}

    seasons.map(function(season) {
        const { id,divisions, offerGenderDivisionOptions, isSeasonSet } = season
        const division = {
					seasonId: id,
					divisions,
					offerGenderDivisionOptions,
					isSeasonSet
        }
        seasonDivisions[id] = division
    })
    return seasonDivisions
  }
    
   export default function seasondivisions(state={},action) {
        const {  payload } = action
        
        switch(action.type) {
          case types.Season.FETCH_ACTIVE_SEASONS: {           
            const { data } = payload
            if (data) {                
                const defaultId = payload.data[0].id
                const seasonDivisions = getDivisions(data)
                const newstate = {
									divisions:seasonDivisions,
                  settingsseason:defaultId,
                  addDivisionMode:false,
									initialstate:{ ...seasonDivisions },
								}
                return Object.assign({},state,{
										values:newstate,
										fields:newstate
                  }
                )
            }
            else {
                return state
            }
          }
          case types.Season.TRIGGER_SEASON: {           
            const { data } = payload
            if (data) {                
              const defaultId = payload.data[data.length - 1].id
              const seasonDivisions = getDivisions(data)
              const response = {
                divisions:seasonDivisions,
                settingsseason:defaultId,
                initialstate:{ ...seasonDivisions },
              }
              return  { 
                ...state, 
                values:
                {
                  ...state.values ,
                  ...response        
                },
                fields: 
                {
                  ...state.fields,
                  ...response 
                }
              }
            }
            else {
                return state
            }
          }
          case  types.Season.ADD_DIVISION_MODE: {
           
           const addDivisionMode = true;
            
             return  { ...state, 
              values: {
                ...state.values ,
                addDivisionMode       
              },
              fields: {
                ...state.fields,
                addDivisionMode
              }
            } 
          }
          case types.Season.ADDING_SEASON_DIVISION: {
            const response = {
             addingseasondivision:true,
             newdivisionsaved:false,
            }
            return  { ...state, 
               values: {
                         ...state.values ,
                         ...response        
                       },
               fields: {
                         ...state.fields,
                         ...response 
                       }
             }
           
           }
           case types.Season.ADD_SEASON_DIVISION: {

            const { data } = payload
            const seasonDivisions = getDivisions(data)
            const response = {
              divisions:seasonDivisions,
              addingseasondivision:false,
              newdivisionsaved:true,
              addDivisionMode: false
            }
            return  { ...state, 
               values: {
                         ...state.values ,
                         ...response        
                       },
               fields: {
                         ...state.fields,
                         ...response 
                       }
             }
           
           }
          default: return state
        }
      } 


// WEBPACK FOOTER //
// ./src/redux/reducers/forms/seasondivisions.js